"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSearchTitlePrefix = void 0;
var _lodash = require("lodash");
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var _searchQuery = require("../models/search-query");
var buildSearchTitlePrefix = (queryOrObject, count) => {
  var _query$filters, _query$filters2;
  var query = _searchQuery.SearchQuery.valuesOf(queryOrObject);
  var propertyTypes = ((_query$filters = query.filters) === null || _query$filters === void 0 ? void 0 : _query$filters.propertyTypes) && query.filters.propertyTypes;
  var beds = (_query$filters2 = query.filters) === null || _query$filters2 === void 0 ? void 0 : _query$filters2.beds;
  var parts = [];
  if (beds && beds.min && beds.max && beds.min === beds.max) {
    if (count > 0) {
      parts.push("".concat(count, ","));
    }
    parts.push("".concat(beds.min, " bedroom"));
  }
  if (count > 0 && parts.length === 0) {
    parts.push(count);
  }
  if (propertyTypes && propertyTypes.length === 1) {
    var firstPropertyType = propertyTypes[0];
    var propertyType = _node.PropertyType[firstPropertyType];
    var propertyTypeLabel = count === 1 ? propertyType.label : propertyType.pluralLabel;
    parts.push(propertyTypeLabel.toLowerCase());
  } else if (!propertyTypes || propertyTypes.length !== 1) {
    if (count === 1) {
      parts.push('property');
    } else {
      parts.push('properties');
    }
  }
  return (0, _lodash.upperFirst)((0, _lodash.toLower)(parts.join(' ')));
};
exports.buildSearchTitlePrefix = buildSearchTitlePrefix;